import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectStyleByRecord } from 'PDF/helpers/documentStyle';

export interface IHeaderItem {
  name: string;
  image: string;
}

interface ITableHeaderProps {
  headers: IHeaderItem[];
  firstCeilWidth: string;
  ceilWidth: string;
}
const colorIndexes = {
  green: 7,
  blue: 0,
  red: 1,
  blueGreen: 0,
  blueRed: 5,
  blueYellow: 5,
};

export const TableHeader = ({ headers, firstCeilWidth, ceilWidth }: ITableHeaderProps) => {
  const firstCeilWidthStyle = { width: firstCeilWidth, marginLeft: 0 };
  const ceilWidthStyle = { width: ceilWidth };
  const withImages = headers.filter(({ image }) => image).length > 0;

  const ceilNameColor = getColorObjectStyleByRecord(colorIndexes, 'backgroundColor');

  return (
    <>
      {withImages && (
        <View style={styles.row}>
          <View style={[styles.ceilImage, firstCeilWidthStyle]} />
          {headers.map(({ image }, index) => (
            <View key={index} style={[styles.ceilImage, ceilWidthStyle]}>
              {!!image && <Image src={image} style={styles.image} />}
            </View>
          ))}
        </View>
      )}
      <View style={styles.row}>
        <View style={[styles.ceilName, ceilNameColor, firstCeilWidthStyle]} />
        {headers.map(({ name }) => (
          <View key={name} style={[styles.ceilName, ceilNameColor, ceilWidthStyle]}>
            <Text style={styles.name}>{name}</Text>
          </View>
        ))}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  ceilName: {
    marginBottom: 4,
    marginLeft: 4,
    paddingVertical: 4,
    paddingHorizontal: 4,
    height: '28px',
  },
  ceilImage: {
    marginBottom: '4px',
    marginLeft: 5,
  },
  image: {
    maxWidth: 103,
    maxHeight: 80,
    objectFit: 'contain',
    objectPositionX: 0,
    objectPositionY: 0,
  },
  name: {
    fontFamily: 'Noto',
    fontSize: '9px',
    lineHeight: 1.3,
    fontWeight: 500,
    color: '#fff',
  },
});
